import axios from 'axios'
import { URL } from '../../util/ambienteActions';
import { LISTAR_FILTROS_EMPRESAS } from '../types';

export default function listarFiltrosEmpresas (codEmpresa) {
  let url = `${URL}/empresas/filtros`;

  if (codEmpresa) {
    url = `${URL}/empresas/filtros/${codEmpresa}`;
  }

  return dispatch => axios.get(url).then(
      response => dispatch({
        type: LISTAR_FILTROS_EMPRESAS,
        payload: response

      })
  );
}
